import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import VersionWebsitesRef from '../../components/versionWebsitesRef.js'
import VersionRef from '../../components/versionRef.js'
import useGoogleCharts from '../../components/useGoogleCharts.js';
import VersionDistributionChart from '../../components/versionDistributionChart.js'
import {TechnologyVersionsPageResult, TechnologyVersion} from '../../../../server/routes/technology.js'

import {
    _printPercent, 
	} from '../../helpers/helpers'

interface TechnologyVersionsProps {
	server: string;
	pageData: unknown;
}

interface ComponentProps {
	props: TechnologyVersionsPageResult;
}

interface ComponentPropsWithVersions extends ComponentProps {
	versions: TechnologyVersion[];
}

interface TechnologyVersionRowProps {
	indexKey?: number;
	technologyName: string;
	technologyURL: string;
	version: TechnologyVersion;
}

export default function TechnologyVersions({server, pageData}: TechnologyVersionsProps) {

    const typedPageData = pageData as TechnologyVersionsPageResult;
	let [data, setData] = useState(typedPageData);
	const google = useGoogleCharts();
    let subtitle: string = 'Vulnerable versions are highlighted in red';
    let cve: boolean = false;

    data.TechnologyVersions.Versions.map((version: TechnologyVersion) => {
        if (version.CVEs!.length) {
            cve = true;
        }
    })
    if (cve === false) {
        subtitle = '';
    }

    // DMK: dont know how to create a good mathematic algorithm
    // so just going to hardcode some values
    let versions: TechnologyVersion[] = [];
    /*
    let noise = 1;
    if (data.TechnologyVersions.Versions.length > 1000) {
        noise = 10;
    } else if (data.TechnologyVersions.Versions.length > 200) {
        noise = 3;
    }
        */
    data.TechnologyVersions.Versions.map((version: TechnologyVersion) => {
    //    if (version.DomainCount > noise)
        {
            versions.push(version);
        }
    })

    return (
		<>
            <section className="section section-sm">
                <div className="container">
                    <TechnologyVersionsHeader props={data}/>
                    <TechnologyVersionsStatistics props={data} versions={versions}/>
                    <VersionDistributionChart 
                        title={`${data.TechnologyLongName} versions distribution`}
                        subtitle={subtitle}
                    //    versions={data.TechnologyVersions.Versions} 
                        versions={versions} 
                        google={google}/>		
                    <TechnologyVersionsList props={data} versions={versions}/>
                </div> 
            </section>

		</>
	)
};

function TechnologyVersionsHeader({props}: ComponentProps) {
    return (<>
        <div className="row row-50">
            <div className="col">
                <h2>
                    <TechnologySmallIcon 
                        technologyIcon={props.TechnologyIcon}
                        technology={props.TechnologyShortName}
                    />
                    &nbsp;{props.TechnologyLongName} versions
                </h2>
                Discovered {props.TechnologyLongName} technology versions
            </div>
        </div>
    </>)
}

function TechnologyVersionsStatistics({props, versions}: ComponentPropsWithVersions) {
	let vulnVersions: number = 0;
	versions.forEach((v: TechnologyVersion) => {
		if (v.Vulnerable) vulnVersions++;
	})

    return (<>
    
    <div className="row row-50">
        <div className="col">
            <br/>
            <h3>{props.TechnologyLongName} versions statistics</h3>
            <table className="table-custom table-custom-striped table-custom-primary">
                <thead>
					<tr>
						<th style={{width: '30%'}}></th>
						<th style={{width: '70%'}}></th> 				
					</tr>
				</thead>
                <tbody>
                    <tr>
                        <td>Total discovered versions</td>
                        <td>
                            <span className="icon text-primary">
                                <b>{versions.length}</b>
                            </span>
                            {' '}{ (versions.length === 1) ? 'version' : 'versions'}
                        </td>
                    </tr>
                    <tr>
                        <td>Total vulnerable versions</td>
                        <td>
                            <span className="icon text-primary">
                                <b>{vulnVersions}</b>
                            </span>
                            {' '}{ (vulnVersions === 0) ? '' : (vulnVersions === 1) ? 'version' : 'versions'}
                        </td>
                    </tr>
                    {
                        props.MostPopularVersion &&                         
                        <tr>
                            <td>Most popular version</td>
                            <td>
                                <span className="icon text-primary">
                                    <b>
                                        <VersionRef 
                                            technology= {{
                                                TechnologyURL:props.TechnologyURL,
                                                Technology:props.TechnologyLongName,
                                                Version:props.MostPopularVersion
                                            }}
                                        />
                                    </b>
                                </span>
                            </td>
                        </tr>
                    }                      
                    {
                        versions.length &&                           
                    
                        <tr>
                            <td>Latest version</td>
                            <td>
                                <span className="icon text-primary">
                                    <b>
                                        <VersionRef 
                                            technology= {{
                                                TechnologyURL:props.TechnologyURL,
                                                Technology:props.TechnologyLongName,
                                                Version:versions[0].Version
                                            }}
                                        />
                                    </b>
                                </span>
                            </td>
                        </tr>                         
                    }                               
                </tbody>
            </table>
        </div>      
    </div>
    <br/>
    <br/>             

    </>)

}

function TechnologyVersionsList({props, versions}: ComponentPropsWithVersions) {
    return (<>
    
        <div className="row row-50">
            <div className="col">  
                <h3>List of {props.TechnologyShortName} versions</h3>
                <br/>
                <br/>
                <table className="table-custom table-custom-striped table-custom-primary">
                        <thead>
                        <tr>
                            <th style={{width: '15%'}}>Vulnerable</th>                            
                            <th style={{width: '25%'}}>Version</th>
                            <th style={{width: '20%'}}>Utilization</th>
                            <th style={{width: '35%'}}>Websites count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            versions.map((version: TechnologyVersion, indexKey: number) => 
                                {
                                    return (<TechnologyVersionInfoRow        
                                        key={indexKey}
                                        technologyName={props.TechnologyLongName} 
                                        technologyURL={props.TechnologyURL}
                                        version={version}
                                    />   
                                    )                                     
                                }

                            )
                        }
                    </tbody>
                </table> 
            </div>  
        </div>  
    </>)
}

function TechnologyVersionInfoRow({indexKey, technologyName, technologyURL, version}: TechnologyVersionRowProps) {
    let bold: boolean = version.MarkerShare! > 0.05;
    return (<>
        <tr key={version.Version}>
            <td>
                {
                version.Vulnerable ? 
                <span className="icon fas fa-exclamation-triangle" style={{color: 'red'}}/>
                :
                <span className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}/>
                }
            </td>  
            <td>
                {
                    bold ?
                    <b><VersionRef technology={{Technology: technologyName,TechnologyURL: technologyURL,Version: version.Version }}/></b>
                    :
                    <VersionRef technology={{Technology: technologyName,TechnologyURL: technologyURL,Version: version.Version }}/>
                }
            </td>
            <td>
                {
                    bold ?
                    <b>{_printPercent(version.MarkerShare)}%</b>
                    :
                    <>{_printPercent(version.MarkerShare)}%</>
                }
            </td>
            <td>               
                 {
                    bold ?
                    <b><VersionWebsitesRef technologyURL={technologyURL} 
                        version = {version.Version}
                        domainCount={version.DomainCount}/> websites</b>
                    :
                    <><VersionWebsitesRef technologyURL={technologyURL} 
                        version = {version.Version}
                        domainCount={version.DomainCount}/> websites</>
                 }
            </td>                      
        </tr>
    </>)
}

/*


function TechnologyVersionInfoRow({indexKey, technologyName, technologyURL, version}) {

    return (<>
    {
        <tr key={version.Version}>
        {
            version.MarkerShare > 0.05 ?
            <>
                <td><b>
                    <VersionRef 
                        technology={{
                            Technology: technologyName,
                            TechnologyURL: technologyURL,
                            Version: version.Version   
                        }}
                    />
                </b></td>
                <td><b>
                    {_printPercent(version.MarkerShare)}%
                </b></td>
                <td><b>
                    <VersionWebsitesRef
                        technologyURL={technologyURL} 
                        version = {version.Version}
                        domainCount={version.DomainCount}
                    /> websites
                </b></td>                
                <td><b>
                    {version.Vulnerable}
                </b></td>
            </>:
            <>
                <td>
                    <VersionRef 
                            technology={{
                                Technology: technologyName,
                                TechnologyURL: technologyURL,
                                Version: version.Version   
                            }}
                    />
                </td>                                            
                <td>
                    {_printPercent(version.MarkerShare)}%
                </td>
                <td>
                    <VersionWebsitesRef
                        technologyURL={technologyURL} 
                        version = {version.Version}
                        domainCount={version.DomainCount}
                    /> websites
                </td>                  
                <td><b>
                    {version.Vulnerable}
                </b></td>                                      
            </>
        }
        </tr>
}
    </>)
}


* */